"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5754],{

/***/ 27767:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Icon_Facebook.3309198b.webp","height":160,"width":160,"blurDataURL":"data:image/webp;base64,UklGRqQAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABP6AmAAFGLg0F9q0aERG4c+pgE9tWY00VAi6xzihAAn00AA52I/ofo/yiw3FwJXgJ3sLXYI/6BFZQOCBGAAAA8AEAnQEqCAAIAAJAOCWUAnQBHoHh/PYAAP7tKFBXdTN4v6ADNOWKa+lgoQmzFx8Al63B3wPWBzxoDATel90SKyd6MuAAAA==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 74065:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Icon_Instagram.0134fd75.webp","height":160,"width":160,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABP6AmAAFGLg0F9q0aERG4c+pgE9tWY00VAi6xzihAAn00AA52I/ofo/yiw3FwJXgJ3sLXYI/6BFZQOCBIAAAA8AEAnQEqCAAIAAJAOCWUAnQFGAN9rc1wAP7qVsOd9XCdhgoA8KHxBjqi47ZUrWpxm03s5E0pqKnaxzwV4i/4R5qyd6MuAAAA","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 8182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Icon_LinkedIn.c298d38f.webp","height":160,"width":160,"blurDataURL":"data:image/webp;base64,UklGRq4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABP6AmAAFGLg0F9q0aERG4c+pgE9tWY00VAi6xzihAAn00AA52I/ofo/yiw3FwJXgJ3sLXYI/6BFZQOCBQAAAAUAIAnQEqCAAIAAJAOCWUAnQEwAHfxAjDexlYAP7CrR7+X2hRP7KvnH7Ux8n/ToiBgBfA3ZGT1wznWLDFoA+qAVvq08nG2D74ShjAnpDLgAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 5037:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Icon_Telegram.abd8c42e.webp","height":80,"width":80,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABN6AmABKGXDQkMNfQGhEReId6sIokq7EgkoEh/WcFCEgKwMFdRP9jtt8MOBGuhWQhBfgGnNmfAVZQOCBIAAAA0AEAnQEqCAAIAAJAOCWUAnQA9F9jUIAA/upOJpZ+zWRToPK/Pjxi/V5sVayGN8HDhd56t+PqYggWitip1Ri2L0STpN2G+LgA","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 61777:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Icon_WhatsApp.4f694f89.svg","height":40,"width":40});

/***/ }),

/***/ 19780:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Icon_Youtube.0693a340.webp","height":80,"width":80,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDgAAAABN6AmABKGXDQkMNfQGhEReId6sIokq7EgkoEh/WcFCEgKwMFdRP9jtt8MOBGuhWQhBfgGnNmfAVZQOCBIAAAAEAIAnQEqCAAIAAJAOCWUAnQBHoJp+iaxwAD+0qcde85X5oSkGwarPgOlCB1s7jz6ncVYcraD+1HU8zQnuMiPHmrJ3o0lgAAA","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 5754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69417);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(94253);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(60461);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(38895);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(22797);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_Constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(40953);
/* harmony import */ var _public_assets_images_home_GromoLogo_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64001);
/* harmony import */ var _public_assets_images_home_playStoreBlack_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75355);
/* harmony import */ var _public_assets_images_home_Icon_Facebook_webp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27767);
/* harmony import */ var _public_assets_images_home_Icon_WhatsApp_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61777);
/* harmony import */ var _public_assets_images_home_Icon_Instagram_webp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74065);
/* harmony import */ var _public_assets_images_home_Icon_LinkedIn_webp__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8182);
/* harmony import */ var _public_assets_images_home_Icon_Youtube_webp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19780);
/* harmony import */ var _public_assets_images_home_Icon_Telegram_webp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5037);
/* harmony import */ var _utils_ImageExport__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(80645);
/* harmony import */ var _mui_icons_material_KeyboardArrowUp__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(90813);
/* harmony import */ var _mui_icons_material_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(75503);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_13__);







// import appStoreBlack from "../public/assets/images/home/appStoreBlack.svg";











function AppFooter() {
    const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_utils_ImageExport__WEBPACK_IMPORTED_MODULE_11__/* .PLAYSTORE_BLACK */ .ZE);
    const [moreAbout, setMoreAbout] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        // if (Utils.getOS()?.toLocaleLowerCase() == "android") {
        setImgSrc(_utils_ImageExport__WEBPACK_IMPORTED_MODULE_11__/* .PLAYSTORE_BLACK */ .ZE);
    // }
    // else if (Utils.getOS()?.toLocaleLowerCase() == "ios") {
    //   setImgSrc(APPSTORE_BLACK);
    // }
    }, []);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
    const redirectToProduct = (redirectUrl)=>{
        localStorage.setItem("hash", redirectUrl);
        setTimeout(()=>{
            router.push("/#our-products");
            setTimeout(()=>{
                router.push("/#".concat(redirectUrl));
            }, 900);
        }, 10);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
        style: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#212736",
            color: "white",
            padding: "3%"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
            sx: {
                height: "90%",
                width: {
                    xs: "95%",
                    md: "90%"
                },
                display: "flex",
                flexDirection: "column",
                maxWidth: "1440px",
                margin: "auto"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    sx: {
                        display: {
                            xs: "grid",
                            md: "flex"
                        },
                        height: "fit-content",
                        width: "100%",
                        justifyContent: "space-evenly"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                            sx: {
                                display: {
                                    xs: "flex",
                                    md: "flex"
                                },
                                flexDirection: {
                                    xs: "column"
                                },
                                width: {
                                    xs: "100%",
                                    md: "35%"
                                },
                                justifyContent: {
                                    xs: "center",
                                    md: "space-between"
                                },
                                alignItems: {
                                    xs: "center",
                                    md: "normal"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    style: {
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: _public_assets_images_home_GromoLogo_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                        alt: "logo",
                                        width: 120,
                                        height: 40,
                                        style: {
                                            margin: "10px 0 5px 0"
                                        },
                                        loading: "lazy"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    sx: {
                                        display: {
                                            xs: "flex",
                                            md: "block"
                                        },
                                        justifyContent: {
                                            xs: "space-between",
                                            md: "center"
                                        },
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                            padding: "4px",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                sx: {
                                                    fontSize: {
                                                        xs: "15px",
                                                        md: "18px"
                                                    },
                                                    maxWidth: "1440px",
                                                    display: {
                                                        xs: "none",
                                                        md: "block"
                                                    }
                                                },
                                                children: [
                                                    "Sell financial products & earn ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: "₹1 Lakh/month"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                            sx: {
                                                margin: "10px 0",
                                                padding: "0",
                                                display: {
                                                    xs: "block",
                                                    md: "flex"
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    href: _utils_Constants__WEBPACK_IMPORTED_MODULE_17__/* .appLink */ .ze,
                                                    "aria-label": "appStoreButton",
                                                    sx: {
                                                        fontSize: "24px",
                                                        display: {
                                                            xs: "none",
                                                            md: "flex"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                        width: 140,
                                                        height: 140,
                                                        src: _public_assets_images_home_playStoreBlack_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                                        alt: "appStoreButton",
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    href: _utils_Constants__WEBPACK_IMPORTED_MODULE_17__/* .appLink */ .ze,
                                                    "aria-label": "download link",
                                                    sx: {
                                                        display: {
                                                            xs: "block",
                                                            md: "none"
                                                        },
                                                        fontSize: "24px"
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                        src: imgSrc,
                                                        width: 140,
                                                        height: 140,
                                                        alt: "download link",
                                                        style: {
                                                            objectFit: "contain"
                                                        },
                                                        loading: "lazy"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    sx: {
                                        display: {
                                            xs: "flex",
                                            md: "flex"
                                        },
                                        justifyContent: {
                                            xs: "space-between",
                                            md: "flex-start"
                                        },
                                        alignItems: "center",
                                        margin: {
                                            xs: "0",
                                            md: "10px 0"
                                        }
                                    },
                                    children: [
                                        {
                                            name: "linkedIn",
                                            img: _public_assets_images_home_Icon_LinkedIn_webp__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
                                            link: "https://www.linkedin.com/company/gromofintech/"
                                        },
                                        {
                                            name: "youtube",
                                            img: _public_assets_images_home_Icon_Youtube_webp__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
                                            link: "https://www.youtube.com/channel/UCn5RV1XAm2Fpq5CRn_aw21A?sub_confirmation=1"
                                        },
                                        {
                                            name: "facebook",
                                            img: _public_assets_images_home_Icon_Facebook_webp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
                                            link: "https://www.facebook.com/gromofintech/"
                                        },
                                        {
                                            name: "twitter",
                                            img: _public_assets_images_home_Icon_WhatsApp_svg__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
                                            link: "https://whatsapp.com/channel/0029Va9ASKX0gcfGBCh00d0z"
                                        },
                                        {
                                            name: "instagram",
                                            img: _public_assets_images_home_Icon_Instagram_webp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
                                            link: "https://www.instagram.com/gromo.fintech/"
                                        },
                                        {
                                            name: "telegram",
                                            img: _public_assets_images_home_Icon_Telegram_webp__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
                                            link: "https://t.me/GroMoFin/"
                                        }
                                    ].map((item)=>{
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            href: item.link,
                                            target: "_blank",
                                            rel: "preload",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                "aria-label": "social media icons",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    src: item.img,
                                                    style: {
                                                        margin: "0px 5px"
                                                    },
                                                    width: 40,
                                                    height: 40,
                                                    loading: "lazy",
                                                    alt: item.name
                                                })
                                            })
                                        }, item.name);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                            sx: {
                                width: {
                                    xs: "100%",
                                    md: "45%"
                                },
                                display: "flex",
                                justifyContent: "right"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    sx: {
                                        width: {
                                            xs: "100%",
                                            md: "45%"
                                        },
                                        paddingBottom: "10px",
                                        borderBottom: "1px solid #212736"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            variant: "body1",
                                            margin: "10px 0",
                                            color: "#9EA2AE",
                                            sx: {
                                                display: "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: "Products"
                                        }),
                                        [
                                            {
                                                title: "Credit Card",
                                                redirect: "CreditCard"
                                            },
                                            {
                                                title: "Savings Account",
                                                redirect: "SavingAccount"
                                            },
                                            {
                                                title: "Demat Account",
                                                redirect: "DematAccount"
                                            },
                                            {
                                                title: "Loan",
                                                redirect: "Loan"
                                            },
                                            {
                                                title: "Line of Credit",
                                                redirect: "Credit"
                                            },
                                            {
                                                title: "Investment",
                                                redirect: "Investment"
                                            },
                                            {
                                                title: "Sell Insurance",
                                                redirect: ""
                                            }
                                        ].map((text, i)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                variant: "body1",
                                                sx: {
                                                    display: {
                                                        xs: "block",
                                                        md: "block"
                                                    },
                                                    cursor: "pointer",
                                                    fontSize: {
                                                        xs: "14px",
                                                        md: "16px"
                                                    },
                                                    fontWeight: "500",
                                                    lineHeight: "20px",
                                                    padding: "6px 0"
                                                },
                                                onClick: ()=>{
                                                    if (text.redirect) {
                                                        redirectToProduct(text.redirect);
                                                    }
                                                },
                                                children: text.title
                                            }, i);
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    sx: {
                                        width: {
                                            xs: "100%",
                                            md: "45%"
                                        },
                                        borderBottom: "1px solid #212736",
                                        paddingBottom: "10px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            variant: "body1",
                                            margin: "10px 0",
                                            color: "#9EA2AE",
                                            sx: {
                                                display: "flex",
                                                justifyContent: "space-between"
                                            },
                                            children: "Company"
                                        }),
                                        [
                                            {
                                                text: "Academy",
                                                path: "https://gromo.co.in/MFtc"
                                            },
                                            {
                                                text: "Partner with us",
                                                path: _utils_Constants__WEBPACK_IMPORTED_MODULE_17__/* .appLink */ .ze
                                            },
                                            {
                                                text: "Blog",
                                                path: "https://gromo.in/blog/"
                                            }
                                        ].map((obj, i)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                                href: obj.path,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    variant: "body1",
                                                    sx: {
                                                        cursor: "pointer",
                                                        fontSize: {
                                                            xs: "14px",
                                                            md: "16px"
                                                        },
                                                        fontWeight: "500",
                                                        lineHeight: "20px",
                                                        padding: "6px 0"
                                                    },
                                                    children: obj.text
                                                })
                                            }, i);
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            href: "/about-us",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                variant: "body1",
                                                sx: {
                                                    cursor: "pointer",
                                                    fontSize: {
                                                        xs: "14px",
                                                        md: "16px"
                                                    },
                                                    fontWeight: "500",
                                                    lineHeight: "20px",
                                                    padding: "6px 0"
                                                },
                                                children: "About us"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                            href: "/careers",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                variant: "body1",
                                                sx: {
                                                    display: {
                                                        cursor: "pointer"
                                                    },
                                                    fontSize: {
                                                        xs: "14px",
                                                        md: "16px"
                                                    },
                                                    fontWeight: "500",
                                                    lineHeight: "20px",
                                                    padding: "6px 0"
                                                },
                                                children: [
                                                    "Careers",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        style: {
                                                            border: "1px solid black",
                                                            padding: "4px 8px",
                                                            borderRadius: "4px",
                                                            background: "#8DD993",
                                                            color: "black",
                                                            fontWeight: "bold",
                                                            fontSize: "14px",
                                                            cursor: "pointer",
                                                            margin: "0px 5px"
                                                        },
                                                        children: "Hiring!"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                            sx: {
                                width: {
                                    xs: "100%",
                                    md: "20%"
                                },
                                borderBottom: "1px solid #212736",
                                paddingBottom: "10px"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    margin: "10px 0",
                                    color: "#9EA2AE",
                                    sx: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        fontSize: {
                                            xs: "14px",
                                            md: "16px"
                                        },
                                        fontWeight: "500",
                                        lineHeight: "20px"
                                    },
                                    children: "Contact Us"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    sx: {
                                        fontSize: {
                                            xs: "14px",
                                            md: "16px"
                                        },
                                        fontWeight: "500",
                                        lineHeight: "20px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            sx: {
                                                padding: "6px 0"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                                style: {
                                                    cursor: "pointer",
                                                    textDecoration: "none",
                                                    color: "white"
                                                },
                                                href: "tel:+918062159334",
                                                children: "+91 8062159334"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            sx: {
                                                padding: "6px 0"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                                style: {
                                                    cursor: "pointer",
                                                    textDecoration: "none",
                                                    color: "white",
                                                    padding: "6px 0"
                                                },
                                                href: "mailto:contact@gromo.in",
                                                children: "contact@gromo.in"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                    style: {
                        background: "#393F50",
                        color: "#393F50",
                        height: "2px"
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    sx: {
                        display: {
                            xs: "block",
                            md: "flex"
                        }
                    },
                    style: {
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0px 8px 8px 8px",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                            sx: {
                                display: {
                                    xs: "grid",
                                    md: "flex"
                                }
                            },
                            style: {
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                gridTemplateColumns: "1fr 1fr"
                            },
                            children: [
                                {
                                    path: "/privacy-policy",
                                    text: "Privacy policy"
                                },
                                {
                                    path: "/term-condition",
                                    text: "Terms & Conditions"
                                },
                                {
                                    path: "#",
                                    text: "Cancellation policy"
                                },
                                {
                                    path: "/data-storage-policy",
                                    text: "Data Storage Policy"
                                }
                            ].map((obj, i)=>{
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                    href: obj.path,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        variant: "body2",
                                        sx: {
                                            fontSize: {
                                                xs: "14px",
                                                md: "16px"
                                            },
                                            fontWeight: "500",
                                            lineHeight: "20px",
                                            margin: {
                                                xs: "10px 0",
                                                md: "10px 8px"
                                            }
                                        },
                                        children: obj.text
                                    })
                                }, i);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            variant: "body2",
                            color: "#9EA2AE",
                            marginTop: 2,
                            children: "\xa9 2024 GroMo. All rights reserved."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                    width: "90%",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        style: {
                            background: "transparent",
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                            style: {
                                backgroundColor: "#212736",
                                color: "white",
                                padding: 0
                            },
                            elevation: 0,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        onClick: ()=>setMoreAbout(!moreAbout),
                                        children: [
                                            "More About GroMo",
                                            moreAbout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowUp__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "About GroMo"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        children: "Do you want to earn money online without investment? Download GroMo to earn extra income from home today!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "What is GroMo ?"
                                                    }),
                                                    [
                                                        {
                                                            text: "GroMo is the best money-earning app that will help you in\n                          starting a business without any investment. Become a GroMo\n                          partner by downloading the GroMo app from Play Store and\n                          sell financial products from different brands to customers\n                          and earn over ₹1,00,000 every month."
                                                        },
                                                        {
                                                            text: "You can attend free training, learn how to sell financial\n                          products to customers and start earning."
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            variant: "body1",
                                                            style: {
                                                                margin: "10px 0"
                                                            },
                                                            children: item.text
                                                        }, i);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "Who can become a GroMo Partner ?"
                                                    }),
                                                    [
                                                        {
                                                            text: "You can be a working professional, a businessman, a\n                          student or a housewife - our app is a one-stop solution\n                          for anybody looking to learn and earn money by selling\n                          financial products. Other than your primary source of\n                          income, you can easily earn extra money from home by\n                          joining GroMo."
                                                        },
                                                        {
                                                            text: "GroMo is one of the best side income sources where you can\n                          engage customers by sharing content with them and getting\n                          the financial product activated."
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            variant: "body1",
                                                            style: {
                                                                margin: "10px 0"
                                                            },
                                                            children: item.text
                                                        }, i);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "What are the benefits of working with GroMo?"
                                                    }),
                                                    [
                                                        {
                                                            title: "Zero Investment business",
                                                            content: "Start your own business with 0 investment"
                                                        },
                                                        {
                                                            title: "Work from homes",
                                                            content: "Get one of the best at-home job opportunities"
                                                        },
                                                        {
                                                            title: "Quick payout",
                                                            content: "Shortest payout cycle in the market"
                                                        },
                                                        {
                                                            title: "Side income source",
                                                            content: "One of the best extra income sources"
                                                        },
                                                        {
                                                            title: "Great customer service",
                                                            content: "Grow your business with help from our customer support team"
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            variant: "body1",
                                                            children: [
                                                                " ",
                                                                i + 1,
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                                    children: [
                                                                        " ",
                                                                        item.title,
                                                                        " "
                                                                    ]
                                                                }),
                                                                ": ",
                                                                item.content,
                                                                " "
                                                            ]
                                                        }, i);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "What financial brands can you sell ?"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: "You can start your online business @0 investment with us today. Sell insurance and financial products from next-gen brands like Axis bank, Kotak 811 bank, Upstox, Paytm Money, Freecharge, Bajaj Finserv, etc. and earn extra income online without investment."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: "You can sell financial products from the following brand categories:"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                        children: [
                                                            "Savings accounts",
                                                            "Insurance",
                                                            "Credit cards",
                                                            "Demat accounts",
                                                            "Credit accounts",
                                                            "Loan",
                                                            "Investments"
                                                        ].map((text, i)=>{
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                onClick: ()=>router.push("/product"),
                                                                children: text
                                                            }, i);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: "...and many other fantastic financial products with our at-home money earning business. Like what we do? Great, there's more!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                                style: {
                                                    margin: "10px 0"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        fontWeight: "bold",
                                                        children: "What are the features of GroMo ?"
                                                    }),
                                                    [
                                                        {
                                                            text: "GroMo is a great platform to sell financial products.\n                         Trust us, you won't find a better way to earn extra online\n                         without investment. Your customers will be happy to get\n                         access to multiple financial products with you and you\n                         will be happy to earn more income from home, all in one\n                         app."
                                                        },
                                                        {
                                                            text: "You can even build a team through referrals and boost your\n                          earning with our app to make money. Here's is a list of\n                          GroMo features you would love:"
                                                        }
                                                    ].map((item, i)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            variant: "body1",
                                                            style: {
                                                                margin: "10px 0"
                                                            },
                                                            children: item.text
                                                        }, i);
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: [
                                                            {
                                                                title: "Get educated",
                                                                content: "Upskill with our free online courses and webinars and become a certified financial advisor while still doing home based work."
                                                            },
                                                            {
                                                                title: "Manage customers",
                                                                content: "Manage your customers and track their status in your GroMo App. Moreover, you can set up reminders to follow up with your customers."
                                                            },
                                                            {
                                                                title: "Engage your customers",
                                                                content: "Keep your audience engaged with personalized content, website and visiting cards to sell financial products."
                                                            },
                                                            {
                                                                title: "Refer and earn",
                                                                content: "Take full advantage of our fantastic referral policy and refer people in your network to GroMo on a regular basis."
                                                            },
                                                            {
                                                                title: "Track your earnings",
                                                                content: " Use your in-app wallet to keep track of your earnings and transfer money to your bank account."
                                                            },
                                                            {
                                                                title: "Data security",
                                                                content: "Securely maintain customer data in your financial app without worrying about any data safety issues."
                                                            }
                                                        ].map((item, i)=>{
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                                variant: "body1",
                                                                children: [
                                                                    i + 1,
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                                        children: item.title
                                                                    }),
                                                                    " : ",
                                                                    item.content
                                                                ]
                                                            }, i);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                        variant: "body1",
                                                        style: {
                                                            margin: "10px 0"
                                                        },
                                                        children: [
                                                            "Get ready to eam money without investment with GroMo. Download our financial app today",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_13___default()), {
                                                                style: {
                                                                    color: "#4D71D0",
                                                                    margin: "0px 5px",
                                                                    cursor: "pointer"
                                                                },
                                                                href: _utils_Constants__WEBPACK_IMPORTED_MODULE_17__/* .appLink */ .ze,
                                                                children: "Google Play Store"
                                                            }),
                                                            "start your job from home."
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = (AppFooter);


/***/ })

}]);